/** @format */
import { MarketCode } from '@mpb-com/feather/enums';
import { useQuery } from '@tanstack/react-query';

import {
    getPriceModifierGroupsQueryKey,
    groupPriceModifierGroups,
} from '@toucan/common/services/model/price-modifier-groups';

import { Milliseconds } from '@toucan/client/global/application';

import { getPriceModifierGroups } from '@toucan/client/core/model';

export const usePriceModifierGroups = (
    modelId: number | null,
    market: MarketCode
) => {
    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Legacy code: do not use as an example.
    return useQuery({
        enabled: Boolean(modelId),
        queryKey: getPriceModifierGroupsQueryKey(modelId),
        queryFn: () => {
            if (modelId) {
                return getPriceModifierGroups(modelId, market);
            }
            return [];
        },
        select: groupPriceModifierGroups,
        staleTime: Milliseconds.ONE_HOUR,
    });
};
